import React from "react";
import { Helmet } from "react-helmet-async";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { FacebookIcon } from "@thrivetribe/mvf.assets.icons.facebook-icon";
import { Body, BodyHeading, BodyContent } from "@thrivetribe/mvf.ui.organisms.body";
import { FullWidthCta, CtaContent, CtaImage } from "@thrivetribe/mvf.ui.molecules.full-width-cta";
import { ImageCard } from "@thrivetribe/mvf.ui.molecules.image-card";
import { ArticleCard, ArticleCardProps } from "@thrivetribe/mvf.ui.molecules.article-card";
import PlayerSupportTeamGraphic from "assets/img/player-support-team.svg";
import { ImagesUrl, PdfsUrl } from "configs/EnvironmentConfig";
import "./PlayerSupport.scss";

const cards: ArticleCardProps[] = [
  {
    title: "Want to join man v fat on Facebook?",
    truncateTitle: false,
    description: "Link up with thousands of blokes all on the same journey as you.",
    imgUrl: `${ImagesUrl}/player-support-facebook-card.webp`,
    imgTitle: "Want to join man v fat on Facebook?",
    onClick: () => {
      window.scroll(0, 0);
      window.open("https://www.facebook.com/groups/672967059853036", "_blank");
    },
    ctaText: (
      <div className="player-support__card__link">
        Find MAN v FAT on Facebook <ButtonArrow /> <FacebookIcon />
      </div>
    ),
  },
  {
    className: "article-card--no-hover",
    title: "Looking for our rule book?",
    description: "Whether you want the gist of things or the nitty gritty details, we've got you covered.",
    imgUrl: `${ImagesUrl}/player-support-rulebook-card.webp`,
    imgTitle: "Looking for our rule book?",
    ctaText: (
      <div className="player-support__card__link">
        <a href={`${PdfsUrl}/rulebook-quick-read.pdf`} target="_blank" rel="noreferrer">
          Quick read
        </a>
        &nbsp;Or&nbsp;
        <a href={`${PdfsUrl}/detailed-rules.pdf`} target="_blank" rel="noreferrer">
          All the details
        </a>
      </div>
    ),
  },
];

export const PlayerSupport = (): React.ReactElement => {
  return (
    <Body className="player-support">
      <Helmet>
        <title>Player Support - MAN v FAT</title>
      </Helmet>
      <BodyHeading>
        <h1>Player Support</h1>
      </BodyHeading>
      <BodyContent>
        <FullWidthCta>
          <CtaImage url={PlayerSupportTeamGraphic} altText={"Player Support Team | MAN v FAT"} />
          <CtaContent>
            <h2>Meet our player support team</h2>
            <p>
              Our incredible Player Support Team keep everything running smoothly so you can kick back and enjoy your
              membership. From questions about your subscription or payments, to compliments, complaints or general
              queries, our Player Support Team can help.
            </p>
            <p>
              Get in touch by emailing <a href="mailto:football@manvfat.com">football@manvfat.com</a> or give us a call
              on <a href="tel:0333 006 8331">0333 006 8331</a>
            </p>
          </CtaContent>
        </FullWidthCta>

        <section className="player-support__cards">
          <ImageCard
            backgroundImage={`${ImagesUrl}/player-support-faq-card.webp`}
            link="https://manvfatfootball.org/Home/FAQs"
            heading={<h3>Burning question about MAN v FAT?</h3>}
            text="Check out our FAQs where we answer some of our most-asked questions."
            ctaText="See FAQs"
          />
          {cards.map((card, index) => (
            <ArticleCard
              key={index}
              className={card.className}
              title={card.title}
              truncateTitle={card.truncateTitle}
              description={card.description}
              imgUrl={card.imgUrl}
              imgTitle={card.imgTitle}
              ctaText={card.ctaText}
              onClick={card.onClick}
            />
          ))}
        </section>
      </BodyContent>
    </Body>
  );
};
